import { render } from "./Menu.vue?vue&type=template&id=0d8697cd&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=0d8697cd&lang=scss&scoped=true"

import exportComponent from "/home/knavarro/Proyectos/IGP/programas-investigacion/cts-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8697cd"]])

export default __exports__